import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axiosConfig from "../../../services/Axios";
import { useForm } from "react-hook-form";
import ItemPackageForm from "./ItemPackageForm";
import { toast } from "react-toastify";
import { pickBy } from "lodash";

function ItemPackageWizard({ item, setItem, setDefinePackaging }) {
  const formUnit = useForm();
  const formBox = useForm();
  const [step, setStep] = useState("unit");
  const { t } = useTranslation();

  const [itemPackageUnit, setItemPackageUnit] = useState(
    item.itemPackages[
      item.itemPackages.findIndex((p) => p.packageType === "unit")
    ] ?? null
  );
  const [totalUnitQuantity, setTotalUnitQuantity] = useState(0);
  const [totalBoxQuantity, setTotalBoxQuantity] = useState(0);

  useEffect(() => {
    if (itemPackageUnit) {
      let itemClone = { ...item };
      let itemPackageUnitFromItem = item.itemPackages.find(
        (p) => p.id === itemPackageUnit.id
      );
      if (!itemPackageUnitFromItem) {
        itemClone.itemPackages.push(itemPackageUnit);
      } else {
        let itemPackageIndex = itemClone.itemPackages.findIndex(
          (p) => p.id === itemPackageUnit.id
        );
        itemClone.itemPackages[itemPackageIndex] = itemPackageUnit;
      }

      setItem(itemClone);
      if (step === "final") {
        setDefinePackaging(false);
      }
    }
  }, [itemPackageUnit]);

  const onSubmitUnit = async (data) => {
    try {
      if (!itemPackageUnit) {
        const sanitizedData = pickBy(
          data,
          (value) => value > 0 || value.length > 0
        );
        await axiosConfig
          .post(process.env.REACT_APP_API_URL + "/api/item_packages", {
            ...sanitizedData,
            item: item["@id"],
          })
          .then((response) => {
            if (response?.status === 201 && response?.data) {
              toast.success(t("settings.items.itemPackage.created"), {
                theme: "colored",
                hideProgressBar: true,
              });
              setItemPackageUnit(response.data);
              setStep("box-question");
              setTotalUnitQuantity(data.quantity);
            }
          });
      } else {
        await axiosConfig
          .patch(
            process.env.REACT_APP_API_URL + itemPackageUnit["@id"],
            {
              ...data,
            },
            { headers: { "Content-Type": "application/merge-patch+json" } }
          )
          .then((response) => {
            if (response?.status === 200 && response?.data) {
              toast.success(t("settings.items.itemPackage.updated"), {
                theme: "colored",
                hideProgressBar: true,
              });
              setItemPackageUnit(response.data);
              setStep("box");
              setTotalUnitQuantity(data.quantity);
            }
          });
      }
    } catch (e) {
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          formUnit.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  const onSubmitBox = async (data) => {
    try {
      const sanitizedData = pickBy(
        data,
        (value) => value > 0 || value.length > 0
      );

      await axiosConfig
        .patch(
          process.env.REACT_APP_API_URL + itemPackageUnit["@id"],
          {
            parentPackage: {
              ...sanitizedData,
              packageType: "box",
              item: item["@id"],
            },
          },
          { headers: { "Content-Type": "application/merge-patch+json" } }
        )
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success(t("settings.items.itemPackage.updated"), {
              theme: "colored",
              hideProgressBar: true,
            });

            setItemPackageUnit(response.data);
            setTotalBoxQuantity(response.data.parentPackage.quantity);
            setStep("pallet-question");
            formBox.reset();
          }
        });
    } catch (e) {
      if (e.response.status !== 200 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          formBox.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  const onSubmitPallet = async (data) => {
    try {
      const sanitizedData = pickBy(
        data,
        (value) => value > 0 || value.length > 0
      );

      await axiosConfig
        .patch(
          process.env.REACT_APP_API_URL + itemPackageUnit.parentPackage["@id"],
          {
            parentPackage: {
              ...sanitizedData,
              packageType: "pallet",
              item: item["@id"],
            },
          },
          { headers: { "Content-Type": "application/merge-patch+json" } }
        )
        .then((response) => {
          if (response?.status === 200 && response?.data) {
            toast.success(t("settings.items.itemPackage.created"), {
              theme: "colored",
              hideProgressBar: true,
            });
            //let newItemPackageUnitParent = { ...itemPackageUnit.parentPackage }

            setItemPackageUnit({
              ...itemPackageUnit,
              parentPackage: response.data,
            });

            setStep("final");
            formBox.reset();
          }
        });
    } catch (e) {
      if (e.response.status !== 201 && e.response.data?.violations) {
        e.response.data.violations.map((v) => {
          formBox.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  return (
    <>
      {step === "unit" && (
        <ItemPackageForm
          form={formUnit}
          formTitle={t("settings.items.itemPackage.wizard.unitTitle", {
            item: item.name,
          })}
          onSubmitForm={onSubmitUnit}
          setDefinePackaging={setDefinePackaging}
          itemPackage={item.itemPackages[0] ?? null}
        />
      )}
      {step === "box-question" && (
        <>
          <div className="w-full font-bold text-red-800 text-center rounded border border-red-200 text-sm p-3 px-4 bg-red-50">
            {t("settings.items.itemPackage.wizard.boxQuestion", {
              quantity: totalUnitQuantity,
            })}
          </div>
          <div className="grid grid-cols-2 mt-5">
            <div className="text-right">
              <span
                className="cursor-pointer btn btn-default h-10 ml-1 font-bold"
                onClick={() => setStep("box")}
              >
                {t("global.btn.yes")}
              </span>
            </div>
            <div>
              <span
                className="cursor-pointer btn btn-default h-10 ml-1 font-bold"
                onClick={() => setDefinePackaging(false)}
              >
                {t("global.btn.no")}
              </span>
            </div>
          </div>
        </>
      )}
      {step === "box" && (
        <>
          <ItemPackageForm
            form={formBox}
            formTitle={t("settings.items.itemPackage.wizard.boxTitle", {
              item: item.name,
              quantity: totalUnitQuantity,
            })}
            onSubmitForm={onSubmitBox}
            setDefinePackaging={setDefinePackaging}
            itemPackageType="box"
            itemPackage={item.itemPackages[0]?.parentPackage ?? null}
          />
        </>
      )}
      {step === "pallet-question" && (
        <>
          <div className="w-full font-bold text-red-800 text-center rounded border border-red-200 text-sm p-3 px-4 bg-red-50">
            {t("settings.items.itemPackage.wizard.palletQuestion", {
              quantity: itemPackageUnit.parentPackage.quantity,
            })}
          </div>
          <div className="grid grid-cols-2 mt-5">
            <div className="text-right">
              <span
                className="cursor-pointer btn btn-default h-10 ml-1 font-bold"
                onClick={() => setStep("pallet")}
              >
                {t("global.btn.yes")}
              </span>
            </div>
            <div>
              <span
                className="cursor-pointer btn btn-default h-10 ml-1 font-bold"
                onClick={() => setDefinePackaging(false)}
              >
                {t("global.btn.no")}
              </span>
            </div>
          </div>
        </>
      )}
      {step === "pallet" && (
        <>
          <ItemPackageForm
            form={formBox}
            formTitle={t("settings.items.itemPackage.wizard.palletTitle", {
              item: item.name,
              quantity: totalBoxQuantity,
            })}
            onSubmitForm={onSubmitPallet}
            setDefinePackaging={setDefinePackaging}
            itemPackageType="pallet"
            itemPackage={
              item.itemPackages[0]?.parentPackage?.parentPackage ?? null
            }
          />
        </>
      )}
    </>
  );
}

export default ItemPackageWizard;
